// This is included individual in each entry point is is used by webpack -
// it specifically handles __webpack_public_path__. We read the value from
// a global variable set in base.html - this allows us to set the
// public path differently depending on env (eg. staging & production can
// use different CDNs)
// @ts-ignore
// eslint-disable-next-line camelcase
__webpack_public_path__ = window.__webpack_public_path__;
